export default __webpack_public_path__ + "static/media/Pallidus Libram.edd23016.jpg";